export const accountMenuItems = [

   {
    label: "Billing",
    path: "/master/billings",
  },
  {
    label: "Bank",
    path: "/master/banks",
  },
  {
    label: "Rates",
    path: "/master/rates",
  },
  // hidden from the sidebar for now; the pages still work by URL
  // {
  //   label: "VAS Types",
  //   path: "/master/vasTypes",
  // },
  // {
  //   label: "VAS Basis",
  //   path: "/master/vasRates",
  // },
  // {
  //   label: "VAS Rules",
  //   path: "/master/vasRules",
  // },
  {
    label: "Value Added Services",
    path: "/master/value-added-services",
  },
];